import { BlockProps, IBlockLocation } from '../../content-blocks/type';
import { LineBlockProps } from './type';

interface Props {
  key: string;
  label: string;
  location: IBlockLocation;
}

export const createLineBlock = (props: Props): LineBlockProps => {
  return {
    type: 'line',
    value: props.label,
    width: props.label.length * 7,
    isVisible: false,
    x: 0,
    y: 0,
    fontSize: 12,
    isBold: false,
    isItalics: false,
    isCapsLocks: false,
    ...props,
  };
};

export function isLineBlock(block: BlockProps): block is LineBlockProps {
  return block.type === 'line';
}
